module.exports = __webpack_public_path__ + "img/cityScapeTwo.e364c496.jpg";